import React, { useEffect, useState } from 'react';
import { useEmployeeSelection } from '../../providers/EmployeeSelectionProvider';
import styles from './employee-selection-warning-header.module.scss';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

export const EmployeeSelectionWarningHeader: React.FC<{
  animate?: boolean;
}> = ({ animate = false }) => {
  const { selectedEmployee } = useEmployeeSelection();
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);
  const [shouldRender, setShouldRender] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);
  const [isExiting, setIsExiting] = useState(false);

  useEffect(() => {
    if (selectedEmployee) {
      setIsExiting(false);
      setShouldRender(true);
      const showTimer = setTimeout(() => {
        setIsVisible(true);
        if (animate) {
          setIsAnimating(true);
        }
      }, 10);
      return () => clearTimeout(showTimer);
    } else if (shouldRender && !isExiting) {
      setIsExiting(true);
      setIsAnimating(false);
      setIsVisible(false);
      const hideTimer = setTimeout(() => {
        setShouldRender(false);
        setIsExiting(false);
      }, 500);
      return () => clearTimeout(hideTimer);
    }

    return undefined;
  }, [selectedEmployee, animate, shouldRender, isExiting]);

  if (!shouldRender) {
    return null;
  }

  return (
    <div
      className={cn(styles.warningHeader, {
        [styles.animate]: animate && isAnimating && isVisible && !isExiting,
        [styles.animateExit]: animate && isExiting,
      })}
    >
      {t('sickness.viewingAs')}: {selectedEmployee?.name}
    </div>
  );
};
